import { render, staticRenderFns } from "./set-product-type.vue?vue&type=template&id=22a1bcca&scoped=true&"
import script from "./set-product-type.vue?vue&type=script&lang=js&"
export * from "./set-product-type.vue?vue&type=script&lang=js&"
import style0 from "./set-product-type.vue?vue&type=style&index=0&id=22a1bcca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a1bcca",
  null
  
)

export default component.exports